<template>
  <div class="elevation-0">
    <v-card elevation="0" class="mb-0">
      <v-row>
        <v-col class="mt-1 text-justify">
          <form-credit-wallet
            v-show="getCloseSetCreditWallet"
          ></form-credit-wallet>
          <form-confirm-credit-wallet
            v-show="getConfirmCreditWallet"
          ></form-confirm-credit-wallet>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import FormCreditWallet from "./FormCreditWallet";
import FormConfirmCreditWallet from "./FormConfirmCreditWallet";
import { mapHelper } from "../../../../store/helper";
export default {
  name: "SetCreditWallet",
  components: { FormConfirmCreditWallet, FormCreditWallet },
  data: () => ({}),

  methods: {
    sleep: function(m) {
      return new Promise(resolve => setTimeout(resolve, m));
    },
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
